import visitorsClassicScenario from './visitors-classic';

/**
 * Sets up Desks Mirage Scenario
 * - `MIRAGE_SCENARIO=desks yarn start:mirage`
 *
 * @param {object} server Mirage Server
 */
export default function (server) {
  const {
    subscription,
    locations: [location],
  } = visitorsClassicScenario(server);

  subscription.update({
    features: [
      'pre_registration_required',
      'billing',
      'sign_in_visitors',
      'custom_notifications',
      'group_sign_in',
      'nda_enabled',
      'visitor_photos',
      'visitor_badge_printing',
      'sms_notification',
      'slideshows',
      'custom_badge',
      'presign_nda',
      'multiple_visitor_types',
      'sign_in_from_invite',
      'slack',
      'analytics',
      'assistants',
      'blacklist',
      'locations_grouping',
      'global_analytics',
      'rooms-calendar-permissions',
    ],
  });

  server.create('flow', 'withES', 'withQuestions', { location });

  const [entry1, entry2] = server.createList('entry', 5, 'withSignInUser');

  const [floor1, floor2] = server.createList('floor', 2, {
    location,
    floorPlanUrl: 'https://picsum.photos/460/300',
  });

  const [floor1desk1, floor1desk2] = server.createList('desk', 10, { floor: floor1 });
  server.createList('desk', 200, { floor: floor2 });

  server.create('reservation', { location, entryId: entry1.id, desk: floor1desk1 });
  server.create('reservation', { location, entryId: entry2.id, desk: floor1desk2 });
}
